import React from 'react';
import { useForumSettings } from '@/hooks/useForumSettings';
import { useAuth } from '@/hooks/useAuth';
import { MaintenanceMode } from './MaintenanceMode';

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

export const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({ children }) => {
  const { getSetting } = useForumSettings();
  const { isAdmin } = useAuth();

  // Don't block the entire app on forum_settings — assume not-in-maintenance
  // until it loads. If maintenance flips true later, the page re-renders.
  
  const isMaintenanceMode = getSetting('maintenance_mode', false);
  const maintenanceMessage = getSetting('maintenance_message', 'We are currently performing scheduled maintenance. Please check back soon!');
  
  // If maintenance mode is enabled and user is not an admin, show maintenance page
  if (isMaintenanceMode && !isAdmin) {
    return <MaintenanceMode message={maintenanceMessage} />;
  }
  
  // If maintenance mode is enabled and user is admin, show normal content with admin indicator
  if (isMaintenanceMode && isAdmin) {
    return (
      <>
        {children}
      </>
    );
  }
  
  // Normal operation - show regular content
  return <>{children}</>;
};